<template>
  <div id="exemptions-deductions" class="table-responsive">
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th scope="col">Description</th>
          <th scope="col" class="text-end">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="2" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="(item, index) in items" v-bind:key="index">
          <td>{{ item.DESCRIPTION }}</td>
          <td class="text-end">{{ item.AMOUNT | currency }}</td>
        </tr>
      </tbody>
      <tfoot class="fw-bold" v-if="items.length">
        <td>Count: {{ items.length }}</td>
        <td class="text-end">{{ total | currency }}</td>
      </tfoot>
    </table>
    <div class="d-flex justify-content-end">
      <div
        v-if="adjustments.AdjustmentExemptionDeductions.length"
        class="text-end d-print-none"
      >
        <button
          type="button"
          class="btn btn-primary btn-sm text-white d-print-none"
          data-bs-toggle="modal"
          data-bs-target="#adjustments-modal"
        >
          Property Adjustments
        </button>
      </div>
      <div
        v-if="
          lteURL &&
            lteInstalled &&
            taxType != 'Personal' &&
            (parcelStatus.trim().toUpperCase() === 'A' ||
              parcelStatus.trim().toUpperCase() === 'ACTIVE')
        "
        class="text-end d-print-none"
      >
        <a
          :href="lteURL"
          class="btn btn-primary btn-sm ms-3 text-white d-print-none"
          id="file-e-forms"
          rel="noopener"
          target="_blank"
        >
          File E-Forms
        </a>
      </div>
    </div>

    <div
      class="modal fade"
      ref="cbmodal"
      id="adjustments-modal"
      tabindex="-1"
      aria-labelledby="adjustments-modal-label"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="adjustments-modal-label">
              Property Value Adjustments
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div>
              <adjustments-component :item="adjustments" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AdjustmentsComponent from "./AdjustmentsComponent";
export default {
  components: {
    AdjustmentsComponent,
  },
  computed: {
    total: function() {
      return this.items.reduce(function(prev, item) {
        return prev + item.AMOUNT;
      }, 0);
    },
    lteURL: function() {
      let url = process.env.VUE_APP_LTE;
      if (!url) {
        return;
      }
      url = url.replace("{{CorpCode}}", this.corpCode);
      url = url.replace("{{Dup}}", this.$route.params.dup);
      return url;
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    corpCode: {
      type: String,
      required: true,
    },
    lteInstalled: {
      type: Boolean,
      required: true,
    },
    taxType: {
      type: String,
      required: true,
    },
    adjustments: {
      type: Object,
      required: true,
    },
    parcelStatus: {
      type: String,
      required: true,
    },
  },
};
</script>
